import { render, staticRenderFns } from "./CompanySalaryComponent.vue?vue&type=template&id=1feaf785&"
import script from "./CompanySalaryComponent.vue?vue&type=script&lang=js&"
export * from "./CompanySalaryComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports